{
  "header": "Under Construction",
  "subheader": "We're sorry. The module {{MODULE}} is currently under construction.",
  "cta": "Take Me Home"
}
